export default {
    headerContainer: {
        display: "flex",
        alignItems: "center",
        columnGap: "60px",
    },

    headerText: {
        display: "flex",
        alignItems: "center",
        columnGap: "10px"
    },

    gridContainer: {
        marginTop: "0px"
    },

    dropdownContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        padding: "25px 0 25px"
    },

    selectDropdown: {
        display: "flex",
        columnGap: "20px",
        alignItems: "end"
    },

    buttonContainer: {
        display: "flex",
        flexWrap: "wrap",
        columnGap: "15px",
        margin: "0px 0 20px"
    },

    button: {
        padding: "6px 22px",
        margin: "5px"
    },
}